import { Send } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/button';
import { Loading } from '@/components/loading';
import env from '@/configs/env';
import useUser from '@/hooks/use-user.hook';

import LanguageSwitcher from './language-switcher';

const NotLoggedMenuItems = (): React.JSX.Element[] => {
  const { t } = useTranslation();
  const { login, isPendingUser } = useUser();

  return [
    isPendingUser ? (
      <Loading className="w-6 h-6 ml-2 mr-2" />
    ) : (
      <Button
        variant="ghost"
        className="text-primary text-base w-auto"
        onClick={() => login()}
      >
        {t('header.login')}
      </Button>
    ),
    <a
      href={`mailto:${env.VITE_DEFAULT_EMAIL_ADDRESS}`}
      rel="noreferrer noopener"
      target="_blank"
      key="contact-us"
      className="flex items-center gap-6"
    >
      <Button
        variant="outline"
        className="group h-10 w-auto rounded-full px-2 py-2 flex items-center justify-center"
      >
        <div className="hidden md:flex mr-2">{t('header.contact_us')}</div>
        <div className="w-6 h-6 rounded-full bg-primary group-hover:bg-white flex items-center justify-center">
          <Send className="text-white group-hover:text-primary w-4 h-4" />
        </div>
      </Button>
    </a>,
    <LanguageSwitcher />,
  ];
};

export default NotLoggedMenuItems;
